var map = {
	"./business-travel.png": 4069,
	"./electricity-consumed-from-grid.png": 32919,
	"./employee-commuting.png": 98554,
	"./fuel-and-energy-not-included-in-scope1or-scope2.png": 26453,
	"./fugitive-combustion.png": 69109,
	"./heat-and-steam-consumed.png": 6876,
	"./leased-assets.png": 14126,
	"./mobile-combustion.png": 94252,
	"./purchased-goods-and-services.png": 31730,
	"./stationary-combustion.png": 1801,
	"./transportation-and-distribution.png": 47362,
	"./waste-generated-in-operations.png": 85534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3812;